import type { ApiResponse } from '@court-sync/shared';
import { ApiError } from '../services/apiClient';

export function unwrapApiData<T>(response: ApiResponse<T>, fallbackMessage: string): T {
  if (response.success && response.data !== undefined && response.data !== null) {
    return response.data;
  }
  throw new ApiError(response.error || fallbackMessage, 0);
}

export function unwrapApiDataOrEmpty<T>(response: ApiResponse<T[]>): T[] {
  if (response.success && response.data) {
    return response.data;
  }
  if (response.success) {
    return [];
  }
  throw new ApiError(response.error || 'Request failed', 0);
}
